export const getServerRevision = (enqueueSnackbar, resultHandler) => {
  let getAPI = "/api/getCodeRevision";
  if (process.env.NODE_ENV !== "production") {
    getAPI = "http://localhost:7071" + getAPI;
  }
  fetch(getAPI, {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
  })
  .then((response) => {
    if (!response.ok) {
      response
        .text()
        .then((text) => {
          throw Error(response.statusText + ": " + text);
        })
        .catch((error) =>
          enqueueSnackbar(error.message, { variant: "error" })
        );
    } else {
      response.json().then((result) => {
        resultHandler(result);
      });
    }
  })
  .catch((error) => enqueueSnackbar(error.message, { variant: "error" }));
};